import { createRouter, createWebHistory } from 'vue-router'
import { nextTick } from 'vue'
// import Home from '@/views/Home.vue'
import AboutUs from '@/views/AboutUs/AboutUs.vue'
import CooperateRoutes from './modules/cooperate'

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home,
  // },
  {
    path: '/',
    name: 'AboutUs',
    component: AboutUs,
  },
  {
    path: '/features/:name',
    name: 'Features',
    component: () => import('@/views/FeaturesIntro/FeaturesIntro.vue'),
  },
  {
    path: '/industrial-application/:name',
    name: 'IndustrialApplication',
    component: () => import('@/views/IndustrialIntro/IndustrialIntro.vue'),
  },
  {
    path: '/sms-reservation',
    name: 'SMSReservation',
    component: () => import('@/views/SMSReservation/SMSReservation.vue'),
  },
  {
    path: '/media-marketing',
    name: 'MediaMarketing',
    component: () => import('@/views/MediaMarketing/MediaMarketing.vue'),
  },
  {
    path: '/plan-content',
    name: 'PlanContent',
    component: () => import('@/views/PlanContent/PlanContent.vue'),
  },
  // {
  //   path: '/application',
  //   name: 'Application',
  //   component: () => import('@/views/Application.vue'),
  // },
  // {
  //   path: '/ecommerce',
  //   name: 'Ecommerce',
  //   component: () => import('@/views/Ecommerce.vue'),
  // },
  // {
  //   path: '/integration',
  //   name: 'Integration',
  //   component: () => import('@/views/Integration.vue'),
  // },
  // {
  //   path: '/plan',
  //   name: 'Plan',
  //   component: () => import('@/views/Plan.vue'),
  // },
  {
    path: '/blog/:cate?',
    name: 'Blog',
    component: () => import('@/views/Blog.vue'),
  },
  {
    path: '/article/:slug',
    name: 'Article',
    component: () => import('../components/Blog/Article.vue'),
  },
  // {
  //   path: '/article-test',
  //   name: 'ArticleTest',
  //   component: () => import('../components/Blog/ArticleTest.vue'),
  // },
  {
    path: '/blog/tag/:tag/:tagId',
    name: 'TagArticle',
    component: () => import('../components/Blog/TagArticle.vue'),
  },
  {
    path: '/columns/:cate?',
    name: 'Columns',
    component: () => import('@/views/Columns.vue'),
  },
  {
    path: '/columns-article/:slug',
    name: 'ColumnsArticle',
    component: () => import('../components/Columns/Article.vue'),
  },
  {
    path: '/columns/tag/:tag/:tagId',
    name: 'ColumnsTagArticle',
    component: () => import('../components/Columns/TagArticle.vue'),
  },
  {
    path: '/tag/:tag/:tagId',
    name: 'TagArticle',
    component: () => import('../components/Tag/Article.vue'),
  },
  {
    // 舊版網站隱私權條款已由《隱私權暨個人資料保護政策》取代
    path: '/policy',
    redirect: { name: 'PrivacyPolicy' },
  },
  {
    path: '/policy/privacy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/Legal/PrivacyPolicy.vue'),
  },
  {
    path: '/policy/consumer-rights',
    name: 'ConsumerRights',
    component: () => import('@/views/Legal/ConsumerRights.vue'),
  },
  {
    path: '/policy/member-terms',
    name: 'MemberTerms',
    component: () => import('@/views/Legal/MemberTerms.vue'),
  },
  {
    path: '/policy/app',
    name: 'AppPolicy',
    component: () => import('@/views/AppPolicy.vue'),
    meta: {
      layout: 'single-page',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
  },
  // {
  //   path: '/tutorial',
  //   name: 'Tutorial',
  //   component: () => import('@/views/Tutorial.vue'),
  // },
  // {
  //   path: '/tutorial/list',
  //   name: 'TutorialList',
  //   component: () => import('@/views/TutorialList.vue'),
  // },
  // {
  //   path: '/tutorial/:slug',
  //   name: 'TutorialContent',
  //   component: () => import('@/views/TutorialContent.vue'),
  // },
  ...CooperateRoutes,
]

let router = createRouter({
  history: createWebHistory(),
  routes: routes,
})

router.afterEach( async(to, from) => {
  const pages = ['Blog', 'Article', 'TagArticle', 'Columns', 'ColumnsArticle', 'ColumnsTagArticle', 'TagArticle']
  const noScroll = pages.includes(to.name)
  if (noScroll) return

  await nextTick()
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
})

router.beforeEach((to, from, next) => {
  console.log(to)
  next()
})

export default router
